import { BlogPost } from "../../../../typings/blogs";
import ContentfulImage from "../../../common/utils/ContentfulImage";
import clock from "../../../../assets/images/time-clock.svg";
import RichText from "../../../common/utils/RichText";
import { Socials } from "./Socials";
import OtherBlogs from "./OtherBlogs";
import { formatDate2 } from "../../../common/utils/helpers";
import Avatar from "../../../common/utils/Avatar";

const BlogDetails = ({
  blog,
  blogs,
}: {
  blog: BlogPost;
  blogs: BlogPost[];
}) => {
  const {
    title,
    slug,
    bannerImage,
    category,
    minuteRead,
    description,
    content,
    authorImage,
    authorName,
  } = blog.fields;
  const { createdAt } = blog?.sys;

  return (
    <div className="flex flex-col gap-12 items-center justify-center">
      <div className="flex w-full items-center flex-col gap-10">
        <div className="flex lg:items-start w-full gap-10 pt-6">
          <div className="hidden lg:flex pt-4 absolute w-full lg:max-w-[4%] xl:max-w-[8%] lg:justify-center xl:justify-end content-center gap-6">
            <div className="flex flex-col items-center justify-end gap-4">
              <div>
                <p className="text-[#717171] text-[1.25rem] font-bold">Share</p>
              </div>
              <Socials title={title} />
            </div>
          </div>
          <div className="flex flex-col w-full items-center justify-center">
            <div className="flex flex-col w-full lg:w-[84%] xl:w-[94%] max-w-[802px] gap-4 lg:gap-10">
              <div className="flex flex-col gap-8">
                <div className="flex flex-col gap-3 items-start">
                  <h2 className="text-[24px] lg:text-[40px] text-[#2D2B4A] font-black">
                    {title}
                  </h2>
                  <div className="flex gap-2 items-center">
                    <Avatar
                      src={authorImage.fields.file.url}
                      alt={`author-img ${title}`}
                      name={authorName}
                      className="size-[24px] rounded-full object-cover"
                    />
                    {/* <ContentfulImage
                      src={authorImage.fields.file.url}
                      alt={`author-img ${title}`}
                      className="size-[24px] rounded-full object-cover"
                    /> */}
                    <span className="text-textBlack2 text-[14px]">
                      {authorName}
                    </span>
                    <div className="rounded-full h-1 w-1 bg-gray-300" />
                    <span className="text-sm text-gray-400">
                      {formatDate2(createdAt)}
                    </span>
                    <div className="rounded-full h-1 w-1 bg-gray-300" />
                    <div className="hidden md:flex items-center gap-1">
                      <img src={clock} className="size-6" alt="" />
                      <span className="text-textBlack2 text-[12px]">
                        {minuteRead} min read
                      </span>
                    </div>
                  </div>
                  <div className="w-full justify-between items-center flex">
                    <div className="bg-primary/10 py-1 mt-1.5 px-3 rounded text-primary text-sm">
                      {category}
                    </div>
                    <div className="flex md:hidden items-center gap-1">
                      <img src={clock} className="size-6" alt="" />
                      <span className="text-textBlack2 text-[12px]">
                        {minuteRead} min read
                      </span>
                    </div>
                  </div>
                </div>
                <div className="w-full lex items-center justofy-center flex-col">
                  <ContentfulImage
                    src={bannerImage.fields.file.url}
                    alt={`author-img ${title}`}
                    className="max-h-[400px] h-full w-full rounded-lg object-cover"
                  />
                </div>
                {/* <div className="flex flex-row justify-between items-center gap-4">
                  <div className="bg-primary/10 py-0.5 px-3 rounded text-primary text-sm">
                    {category}
                  </div>
                  <div className="flex items-center gap-1">
                    <img src={clock} className="size-7" alt="" />
                    <span className="text-textBlack2 text-[14px]">
                      {minuteRead} min read
                    </span>
                  </div>
                </div> */}
                <div>
                  <p className="text-lg text-[#666481]">{description}</p>
                </div>
              </div>

              <div>
                <RichText content={content} />
              </div>
              <div className="flex lg:hidden flex-row items-center gap-2">
                <div>
                  <p className="text-[1.25rem] text-[#717171] font-bold">
                    Share
                  </p>
                </div>
                <Socials title={title} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <OtherBlogs slug={slug} blogs={blogs} />
    </div>
  );
};

export default BlogDetails;
